const SAFE_FAILURE_CATEGORIES = new Set([
  'configuration',
  'high-latency',
  'insufficient-valid-samples',
  'invalid-latency',
  'malformed-response',
  'network',
  'response',
  'timeout',
]);

const isValidThreshold = thresholdMs => (
  typeof thresholdMs === 'number'
  && Number.isFinite(thresholdMs)
  && thresholdMs > 0
);

const boundedCount = value => (
  Number.isInteger(value) && value >= 0 ? Math.min(value, 5) : 0
);

const getMeasurementTelemetry = measurement => {
  const status = measurement?.status;
  const failureCategory = SAFE_FAILURE_CATEGORIES.has(measurement?.failureCategory)
    ? measurement.failureCategory
    : 'unavailable';

  return {
    validSampleCount: boundedCount(measurement?.validSampleCount),
    attemptCount: boundedCount(measurement?.attemptCount),
    latencyCategory: status === 'available' ? 'accepted' : failureCategory,
  };
};

const isValidMeasurement = measurement => (
  measurement?.status === 'available'
  && typeof measurement.offsetMs === 'number'
  && Number.isFinite(measurement.offsetMs)
  && Number.isInteger(measurement.validSampleCount)
  && measurement.validSampleCount > 0
);

const buildDecision = (outcome, reason, measurement) => ({
  outcome,
  telemetry: {
    outcome,
    reason,
    ...getMeasurementTelemetry(measurement),
  },
});

export const classifyClockSkew = ({
  thresholdMs,
  measurement,
} = {}) => {
  if (!isValidThreshold(thresholdMs)) {
    return buildDecision('generic-authentication', 'policy-unavailable', measurement);
  }

  if (!isValidMeasurement(measurement)) {
    return buildDecision('generic-authentication', 'measurement-unavailable', measurement);
  }

  if (Math.abs(measurement.offsetMs) > thresholdMs) {
    return buildDecision('clock-specific', 'measured-offset', measurement);
  }

  return buildDecision('generic-authentication', 'within-threshold', measurement);
};

export default classifyClockSkew;
